import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import associateServices from "../../../services";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import InformationToast from "../../../components/toast/InformationToast";
import SlimSelect from "slim-select";

const PhoneSettings = () => {

    const {user} = useSelector(state => state.authenticationReducer)
    const {configuration} = useSelector(state => state.globalReducer)

    const {t} = useTranslation()
    const [countries, setCountries] = useState([])
    const [code, setCode] = useState('')
    const [number, setNumber] = useState('')
    const [showOtp, setShowOtp] = useState(false)
    const [loading, setLoading] = useState(false)
    const [verified, setVerified] = useState(false)
    const [select, setSelect] = useState(null)
    const [otp, setOtp] = useState('')
    const [secret, setSecret] = useState('')


    useEffect(() => {
        if (configuration?.country) {
            console.log('=countries ', countries)
            const thec = countries?.find(pp => pp.iso2 === configuration?.country)

            console.log('thec  =',thec)
            if (thec)
                select?.setSelected([thec.id?.toString()])
        }
    }, [configuration?.country, countries, select])

    useEffect(() => {
        setVerified(!!user?.phone_verified_at)
        associateServices.getCountryList({}).then(res => setCountries(res?.data || []))
    }, [user?.phone_verified_at])

    useEffect(() => {
        if (countries?.length >= 1) {
            setSelect(
                new SlimSelect({
                    select: '#countries',
                    events: {
                        afterChange: newVal => {
                            setCode(newVal[0].value)
                        }
                    }
                })
            )
        }
    }, [countries])

    const checkPhone = (instance) => {

        associateServices.checkPhone({...instance, otp, secret}).then(res => {
            if (res?.status !== 200)
                return toast.error(t(`api-notifications.${res?.errors}`))


            setCode('')
            setNumber('')
            setShowOtp(false)

            toast(<InformationToast
                icon={'ti-check'}
                message={`api-notifications.verification-code-is-verified`}
                title={t(`general.information`)}
            />)
        })

    }

    const handleVerify = () => {
        const instance = {
            country_id: code,
            number
        }


        if (showOtp)
            return checkPhone(instance)


        setLoading(true)
        associateServices.verifyPhone(instance).then(res => {
            setLoading(false)
            if (res?.status !== 200)
                return toast.error(t(`api-notifications.${res?.errors}`))


            setSecret(res?.data)
            setShowOtp(true)
        })
    }
    return (
        <div className="settings">
            <h3 className="settings__title">
                {t('settings.general.phone')}

                {
                    verified && <span className="settings__level">
                        <span className="green">
                             {t('general.verified')}
                        </span>
                     </span>
                }
            </h3>
            <div className="settings__form">
                <div className="row">
                    <div className="col-12 col-md-8 col-lg-12 col-xxl-10">
                        <div className="row">
                            <div className="col-12 col-xl-8 col-xxl-6">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('settings.general.country-code')}<b>*</b>
                                    </label>
                                    <select
                                        id="countries"
                                        className="form__select"
                                        disabled={showOtp}
                                    >
                                        <option value=""></option>
                                        {
                                            countries?.map(country =>
                                                <option value={country.id} key={country.id}>
                                                    +({country.phone_code}) {country.native}
                                                </option>
                                            )
                                        }

                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-xl-8 col-xxl-6">
                                <div className="form__group">
                                    <label htmlFor="" className="form__label">
                                        {t('settings.general.phone-number')}<b>*</b>
                                    </label>
                                    <input
                                        disabled={showOtp}
                                        value={number}
                                        onChange={e => setNumber(e.target.value)}
                                        type="text" className="form__input"/>
                                </div>
                            </div>

                            {
                                showOtp && <div className="col-12 col-xl-8 col-xxl-6">
                                    <div className="form__group">
                                        <label htmlFor="" className="form__label">
                                            {t('settings.general.verification-code')}<b>*</b>
                                        </label>
                                        <input
                                            value={otp}
                                            onChange={e => setOtp(e.target.value)}
                                            type="text" className="form__input"/>
                                    </div>
                                </div>
                            }
                        </div>


                    </div>
                </div>
            </div>
            <div className="settings__actions">
                <div className="settings__btns">
                    <button
                        disabled={verified ? true : showOtp ? (loading || !code || !number || !otp) : (loading || !code || !number)}
                        onClick={handleVerify}
                        className="settings__btn settings__btn--clean" type="button">
                        {showOtp ? t('settings.general.verify-number') : t('settings.general.update-number')}
                    </button>
                </div>
            </div>
        </div>


    )

}


export default PhoneSettings
